import type { Feature } from "../components/FeatureSection";
import { SAMPLE_POSTER_SRC, SAMPLE_VIDEO_SRC } from "./media";

export const FEATURES: Feature[] = [
  {
    id: "journeys",
    eyebrow: "Journeys",
    title: "Give every pursuit its own home",
    description:
      "Create a journey for anything you're working on — fitness, music, a side project, a life change. Each one gets its own timeline, icon, and visibility settings so you control who sees what.",
    bullets: [
      "Organize multiple pursuits in one app",
      "Choose private, friends-only, or public visibility",
      "Archive finished journeys without losing your history",
    ],
    posterSrc: SAMPLE_POSTER_SRC,
    videoSrc: SAMPLE_VIDEO_SRC,
    recordingLabel: "Drop screen recording: journeys.mp4",
    alt: "Creating and browsing journeys in Progress",
    dark: true,
  },
  {
    id: "daily-steps",
    eyebrow: "Daily steps",
    title: "One short video. Every day.",
    description:
      "Record a quick clip from your camera or photo library, trim it down, and log today's progress. Steps stack into a visual timeline you can scroll back through whenever you need proof that you're moving forward.",
    bullets: [
      "Record in-app or upload from your library",
      "Trim clips and add notes or custom fields",
      "See your streak build day by day",
    ],
    posterSrc: SAMPLE_POSTER_SRC,
    videoSrc: SAMPLE_VIDEO_SRC,
    recordingLabel: "Drop screen recording: daily-step.mp4",
    alt: "Recording and uploading a daily progress video",
    reversed: true,
  },
  {
    id: "chapters",
    eyebrow: "Chapters",
    title: "Break big goals into chapters",
    description:
      "Chapters mark the phases of your journey — learning chords before songs, couch-to-5K before a half marathon. Set a goal for each chapter and even attach a reference video showing what success looks like.",
    bullets: [
      "Define goals for each phase of your journey",
      "Attach a reference video for inspiration",
      "Assign steps to chapters as you go",
    ],
    posterSrc: SAMPLE_POSTER_SRC,
    videoSrc: SAMPLE_VIDEO_SRC,
    recordingLabel: "Drop screen recording: chapters.mp4",
    alt: "Creating chapters with goals in a journey",
    dark: true,
  },
  {
    id: "montages",
    eyebrow: "Montages",
    title: "Turn your clips into highlight reels",
    description:
      "Select your best steps, trim the highlights, and stitch them into a montage — with your original audio, a built-in track, or your own music. Watch weeks of effort compress into something you actually want to share.",
    bullets: [
      "Pick clips and fine-tune trim ranges",
      "Add music or keep the original audio",
      "Share montages with friends or publicly",
    ],
    posterSrc: SAMPLE_POSTER_SRC,
    videoSrc: SAMPLE_VIDEO_SRC,
    recordingLabel: "Drop screen recording: montage.mp4",
    alt: "Building a montage from daily step clips",
    reversed: true,
  },
  {
    id: "social",
    eyebrow: "Friends & feed",
    title: "Stay accountable together",
    description:
      "Add friends, browse their progress in a vertical feed, and leave comments on steps and montages. Follow public journeys from people you admire. Progress works as a personal diary — or a shared one.",
    bullets: [
      "Friend requests by @username",
      "Scroll a feed of friends' latest steps",
      "Comment on steps and montages",
    ],
    posterSrc: SAMPLE_POSTER_SRC,
    videoSrc: SAMPLE_VIDEO_SRC,
    recordingLabel: "Drop screen recording: feed.mp4",
    alt: "Browsing the friends activity feed",
    dark: true,
  },
  {
    id: "reminders",
    eyebrow: "Reminders",
    title: "Never lose the streak",
    description:
      "Set per-journey reminder schedules — pick the days and time that work for you. Push notifications and in-app nudges help you show up, even on the days motivation doesn't.",
    bullets: [
      "Custom schedules per journey",
      "Push notifications when it's time",
      "Missing-step banner on your home screen",
    ],
    posterSrc: SAMPLE_POSTER_SRC,
    videoSrc: SAMPLE_VIDEO_SRC,
    recordingLabel: "Drop screen recording: reminders.mp4",
    alt: "Setting journey reminders in Progress",
    reversed: true,
  },
];
